import s from './_.module.css'

const DrawerHeader = () => {
  const subTitle =
    'Select the content category and we will assign an expert from our talent marketplace'

  return (
    <div className={s.header}>
      <div className={s.titles}>
        <span className={s.mainTitle}>What do you want to create today?</span>
        <span className={s.subTitle}>{subTitle}</span>
      </div>
    </div>
  )
}

export default DrawerHeader
